import { useDispatch, useSelector } from 'react-redux'
import type { RootState, AppDispatch } from './store'

/**
 * Use these typed hooks instead of plain useDispatch/useSelector.
 * They are pre-typed with RootState and AppDispatch.
 *
 * Usage:
 *   const dispatch = useAppDispatch()
 *   const sidebar = useAppSelector((state) => state.ui.sidebarOpen)
 */
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector = <T>(selector: (state: RootState) => T): T =>
  useSelector<RootState, T>(selector)
